import { TFunction } from "i18next";

import { SearchIcon } from "@dotnet/telematics-design-system";

import { ClearInputIcon } from "../../../../../../InputField/components/ClearInputIcon";
import InputField from "../../../../../../InputField/InputField";

interface SearchVehicleProps {
  t: TFunction<"translation", undefined>;
  searchValue: string;
  handleSearchValue: (e: React.ChangeEvent<HTMLInputElement>) => void;
  clearSearchValue: () => void;
  error: string | null;
}

const SearchVehicle = ({
  t,
  searchValue,
  handleSearchValue,
  clearSearchValue,
  error
}: SearchVehicleProps) => {
  return (
    <InputField
      data-testid="search-device-input"
      autoFocus
      fullWidth
      size="medium"
      placeholder={t("Search##find device##search vehicle IMEI")}
      iconLeft={<SearchIcon />}
      value={searchValue}
      onChange={handleSearchValue}
      iconRight={
        <ClearInputIcon value={searchValue} clearValue={clearSearchValue} />
      }
      errorText={error}
    />
  );
};

export default SearchVehicle;
